import { combineReducers } from 'redux';
import searchinputReducer from './searchinputReducer'
import productReducer from './productReducer'
import productsReducer from './productsReducer'
import intervalReducer from './intervalReducer'
import suggest_productsReducer from './suggest_productsReducer'
import promotion_productsReducer from './promotion_productsReducer'
import carouselReducer from './carouselReducer'
import edit_user_info_form_initial_reducer from './edit_user_info_form_initial_reducer'
import user_reducer from './user_reducer'
import cart_products_reducer from './cart_products_reducer'
import cart_extraproducts_reducer from './cart_extraproducts_reducer'
import geo_location_reducer from './geo_location_reducer'
import search_label_reducer from './search_label_reducer'
import loading_search_page_reducer from './loading_search_page_reducer'
import check_cart_products_price_response_reducer from './check_cart_products_price_response_reducer'
import payment_stage_reducer from './payment_stage_reducer'
import delivery_time_reducer from './delivery_time_reducer'
import delivery_charge_reducer from './delivery_charge_reducer'
import button_user_info_page_reducer from './button_user_info_page_reducer'
import customer_credit_card_reducer from './customer_credit_card_reducer'
import event_products_reducer from './event_products_reducer'
import event_products2_reducer from './event_products2_reducer'
import overlay_trigger_reducer from './overlay_trigger_reducer'
import productsForRandomReducer from './productsForRandomReducer'
import blogsReducer from './blogsReducer'
import blogReducer from './blogReducer'
import promocodeReducer from './promocodeReducer'

import orderhistory_reducer from './orderhistory_reducer'
import loadingorderhistory_reducer from './loadingorderhistory_reducer'

import { reducer as formReducer } from 'redux-form'

const rootReducer = combineReducers({
  form: formReducer,
  searchinput: searchinputReducer,
  interval: intervalReducer,
  product: productReducer,
  products: productsReducer,
  suggest_products: suggest_productsReducer,
  promotion_products: promotion_productsReducer,
  carouselstate: carouselReducer,
  edit_user_info_form_initial_reducer: edit_user_info_form_initial_reducer,
  user_reducer: user_reducer,
  cart_products_reducer: cart_products_reducer,
  cart_extraproducts_reducer: cart_extraproducts_reducer,
  geo_location_reducer: geo_location_reducer,
  search_label_reducer: search_label_reducer,
  loading_search_page_reducer: loading_search_page_reducer,
  orderhistory_reducer: orderhistory_reducer,
  check_cart_products_price_response_reducer: check_cart_products_price_response_reducer,
  payment_stage_reducer: payment_stage_reducer,
  delivery_time_reducer: delivery_time_reducer,
  delivery_charge_reducer: delivery_charge_reducer,
  button_user_info_page_reducer: button_user_info_page_reducer,
  customer_credit_card_reducer: customer_credit_card_reducer,
  event_products_reducer: event_products_reducer,
  event_products2_reducer: event_products2_reducer,
  overlay_trigger_reducer: overlay_trigger_reducer,
  productsForRandomReducer: productsForRandomReducer,
  blogsReducer,
  blogReducer,
  promocodeReducer,

  loadingorderhistory_reducer: loadingorderhistory_reducer
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/reducers/index.js